import React from 'react'

//Dashboard
import Dashboard from '../Pages/Dashboard'

//Dashboard
import Taskman from '../Pages/Taskman'

// Import Calender
import Calender from '../Pages/Calender'

// Import MyOrder
import MYO0001 from '../Pages/MYO0001'

// Import Calender
import Cot002 from '../Pages/Cot002'

// Import Permissao
import PermissaoEdit from '../Pages/Permissao/permissao-edit'

// Import E-mail
import Inbox from '../Pages/E-mail/Inbox'
import ReadEmail from '../Pages/E-mail/ReadEmail'
import EmailCompose from '../Pages/E-mail/EmailCompose'

// Import Authentication pages
import Login from '../Pages/Authentication/Login'
import ForgetPasswordPage from '../Pages/Authentication/ForgetPassword'
import Logout from '../Pages/Authentication/Logout'
import UserProfile from '../Pages/Authentication/user-profile'

// Import Utility Pages
import StarterPage from '../Pages/Utility/Starter-Page'
import Maintenance from '../Pages/Utility/Maintenance-Page'
import ComingSoon from '../Pages/Utility/ComingSoon-Page'
import TimeLine from '../Pages/Utility/TimeLine-Page'
import FAQs from '../Pages/Utility/FAQs-Page'
import Pricing from '../Pages/Utility/Pricing-Page'
import Error404 from '../Pages/Utility/Error404-Page'
import Error500 from '../Pages/Utility/Error500-Page'

// Import UIElement Pages
import UiAlerts from '../Pages/Ui/UiElements/UiAlerts'
import UiBadge from '../Pages/Ui/UiElements/UiBadge'
import UiBreadcrumb from '../Pages/Ui/UiElements/UiBreadcrumb'
import UiButtons from '../Pages/Ui/UiElements/UiButtons'
import UiCards from '../Pages/Ui/UiElements/UiCards'
import UiCarousel from '../Pages/Ui/UiElements/UiCarousel'
import UiDropdown from '../Pages/Ui/UiElements/UiDropdowns'
import UiGrid from '../Pages/Ui/UiElements/UiGrid'
import UiImages from '../Pages/Ui/UiElements/UiImages'
import UiLightbox from '../Pages/Ui/UiElements/UiLightbox'
import UiModals from '../Pages/Ui/UiElements/UiModals'
import UiOffcanvas from '../Pages/Ui/UiElements/UiOffcanvas'
import UiRangeSlider from '../Pages/Ui/UiElements/UiRangeSlider'
import UiSessionTimeout from '../Pages/Ui/UiElements/UiSessionTimeout'
import UiPagination from '../Pages/Ui/UiElements/UiPagination'
import UiProgressBars from '../Pages/Ui/UiElements/UiProgressBars'
import UiPlaceholders from '../Pages/Ui/UiElements/UiPlaceholders'
import UiTabs from '../Pages/Ui/UiElements/UiTabs&Accordions'
import UiTypography from '../Pages/Ui/UiElements/UiTypography'
import UiToasts from '../Pages/Ui/UiElements/UiToasts'
import UiVideo from '../Pages/Ui/UiElements/UiVideo'
import UiPopovers from '../Pages/Ui/UiElements/UiPopovers&Tooltips'
import UiRating from '../Pages/Ui/UiElements/UiRating'

// Import Ui/Forms
import FormCustom from '../Pages/Ui/Forms/FormCustom.js'
import FormEditors from '../Pages/Ui/Forms/FormEditors'
import FormUpload from '../Pages/Ui/Forms/FormUpload'
import FormXeditable from '../Pages/Ui/Forms/FormXeditable'
import FormMask from '../Pages/Ui/Forms/FormMask'
import FormElements from '../Pages/Ui/Forms/FormElements'
import FormAdvanced from '../Pages/Ui/Forms/FormAdvanced'
import FormValidations from '../Pages/Ui/Forms/FormValidations'
import FormWizard from '../Pages/Ui/Forms/FormWizard'

// Import Tables
import BasicTable from '../Pages/Ui/Tables/BasicTable.js'
import ListJs from '../Pages/Ui/Tables/ListTables/ListTables'
import DataTable from '../Pages/Ui/Tables/DataTables/DataTables'

// Import Charts
import ApexCharts from '../Pages/Ui/Charts/ApexCharts'
import ChartJs from '../Pages/Ui/Charts/ChartjsCharts'
import Sparklinechart from '../Pages/Ui/Charts/SparklineCharts'
import FloatChart from '../Pages/Ui/Charts/FloatCharts'
import JknobCharts from '../Pages/Ui/Charts/JqueryKnobCharts'

// Import Icon Pages
import IconMaterialdesign from '../Pages/Ui/Icons/IconMaterialdesign'
import IconFontawesome from '../Pages/Ui/Icons/IconFontAwesome'
import IconDripicons from '../Pages/Ui/Icons/IconDrip'
import IconBoxicons from '../Pages/Ui/Icons/IconBoxicons'

// Import Map Pages
import VectorMaps from '../Pages/Ui/Maps/VectorMap'
import GoogleMap from '../Pages/Ui/Maps/GoogleMap'
import Ui from '../Pages/Ui'
import PowerBI from '../Pages/PowerBI/index.js'
import ErrorPermissionDenied from '../Pages/Utility/ErrorPermissionDenied.js'

import BI_WS0000 from '../Pages/BI_WS0000'
import BI_WS0001 from '../Pages/BI_WS0001/index.js'
import BI_WS0002 from '../Pages/BI_WS0002/index.js'
import BI_WS0003 from '../Pages/BI_WS0002/BI_WS0003/index.js'
import BI_WS0004 from '../Pages/BI_WS0002/BI_WS0004/index.js'
import BI_WS0005 from '../Pages/BI_WS0002/BI_WS0005/index.js'
import BI_WS0010 from '../Pages/BI_WS0010/index.js'

import LegalContentPage from '../Pages/LegalContentPage/index.js'
import BI_EX0000 from '../Pages/BI_EX0000/index.js'

import NO005 from '../Pages/BI_WS0002/NO005/index.js'
import NO006 from '../Pages/PL0001/NO006/index.js'

import NO008 from '../Pages/PL0001/NO008/index.js'
import {
  LOGIN,
} from '../helpers/routes_helper.js'
import { Navigate } from 'react-router-dom'
import SuspensePage from '../Pages/Utility/Suspense-Page.js'
import config from '../config.js'
import JSONToolsView from '../Pages/Ui/Tools/JSONToolsView.js'

const authProtectedRoutes = [
  {
    path: '/MYO0001',
    component: <MYO0001 />,
    breadcrumbItems: [
      { pathname: 'Home', path: '/' },
      { pathname: 'MyOrder', path: '/MYO0001' }
    ]
  },

  //dashboard
  { path: '/dashboard', component: <Dashboard /> },
  { path: '/BI_WS0000', component: <BI_WS0000 /> },

  // Permissao
  { path: '/permissao', component: <MYO0001 /> },
  { path: '/permissao-insert', component: <MYO0001 /> },
  { path: '/permissao-edit/:id', component: <PermissaoEdit /> },

  // Busca
  {
    path: '/BI_WS0001',
    component: <BI_WS0001 />
  },

  //Configurações do Usuario
  {
    path: '/BI_WS0002',
    component: <BI_WS0002 />
  },
  {
    path: '/BI_WS0003',
    component: <BI_WS0003 />
  },
  {
    path: '/BI_WS0004',
    component: <BI_WS0004 />
  },
  {
    path: '/BI_WS0005',
    component: <BI_WS0005 />
  },
  // /BI_WS0007 virou transação dinamica
  // { path: "/BI_WS0007", component: <BI_WS0007/> },
  // {
  //   path: '/BI_WS0008',
  //   component: <BI_WS0008 />
  // },
  // {
  //   path: '/BI_WS0009',
  //   component: <BI_WS0009 />
  // },
  {
    path: '/BI_WS0010',
    component: <BI_WS0010 />
  },

  {
    path: '/NO_005',
    component: <NO005 />
  },
  {
    path: '/NO_006',
    component: <NO006 />
  },
  {
    path: '/NO_008',
    component: <NO008 />
  },

  // Calender
  { path: '/calendar', component: <Calender /> },

  // Cot001
  { path: '/taskman', component: <Taskman /> },

  // Cot002
  { path: '/cot002', component: <Cot002 /> },

  // Power BI
  { path: '/power-bi', component: <PowerBI /> },

  // Profile
  { path: '/userprofile', component: <UserProfile /> },

  // E-mail
  { path: '/inbox', component: <Inbox /> },
  { path: '/read-email', component: <ReadEmail /> },
  { path: '/compose-email', component: <EmailCompose /> },

  // Utility Pages
  { path: '/pages-starter', component: <StarterPage /> },
  { path: '/pages-timeline', component: <TimeLine /> },
  { path: '/pages-faqs', component: <FAQs /> },
  { path: '/pages-pricing', component: <Pricing /> },

  ...(config.NODE_ENV === 'development' ? [
    // Ui Labolatory
    { path: '/ui', component: <Ui /> },
  
    // Ui/UiElements Pages
    { path: '/ui-alerts', component: <UiAlerts /> },
    { path: '/ui-badge', component: <UiBadge /> },
    { path: '/ui-breadcrumb', component: <UiBreadcrumb /> },
    { path: '/ui-buttons', component: <UiButtons /> },
    { path: '/ui-cards', component: <UiCards /> },
    { path: '/ui-carousel', component: <UiCarousel /> },
    { path: '/ui-dropdowns', component: <UiDropdown /> },
    { path: '/ui-grid', component: <UiGrid /> },
    { path: '/ui-images', component: <UiImages /> },
    { path: '/ui-lightbox', component: <UiLightbox /> },
    { path: '/ui-modals', component: <UiModals /> },
    { path: '/ui-offcanvas', component: <UiOffcanvas /> },
    { path: '/ui-rangeslider', component: <UiRangeSlider /> },
    { path: '/ui-sessiontimeout', component: <UiSessionTimeout /> },
    { path: '/ui-pagination', component: <UiPagination /> },
    { path: '/ui-progressbars', component: <UiProgressBars /> },
    { path: '/ui-placeholders', component: <UiPlaceholders /> },
    { path: '/ui-tabs-accordions', component: <UiTabs /> },
    { path: '/ui-typography', component: <UiTypography /> },
    { path: '/ui-toasts', component: <UiToasts /> },
    { path: '/ui-video', component: <UiVideo /> },
    { path: '/ui-popovers', component: <UiPopovers /> },
    { path: '/ui-rating', component: <UiRating /> },
  
    // Ui/Forms pages
    { path: '/form-elements', component: <FormElements /> },
    { path: '/form-validation', component: <FormValidations /> },
    { path: '/form-advanced', component: <FormAdvanced /> },
    { path: '/form-editor', component: <FormEditors /> },
    { path: '/form-custom', component: <FormCustom /> },
    { path: '/form-uploads', component: <FormUpload /> },
    { path: '/form-editors', component: <FormXeditable /> },
    { path: '/form-wizard', component: <FormWizard /> },
    { path: '/form-mask', component: <FormMask /> },
  
    // Ui/Tables pages
    { path: '/tables-basic', component: <BasicTable /> },
    { path: '/tables-listjs', component: <ListJs /> },
    { path: '/table-datatables', component: <DataTable /> },
  
    // Ui/Charts Pages
    { path: '/chart-apexcharts', component: <ApexCharts /> },
    { path: '/chart-chartjscharts', component: <ChartJs /> },
    { path: '/chart-floatcharts', component: <FloatChart /> },
    { path: '/chart-jknobcharts', component: <JknobCharts /> },
    { path: '/chart-sparklinecharts', component: <Sparklinechart /> },
  
    // Ui/Icons Pages
    { path: '/icon-boxicon', component: <IconBoxicons /> },
    { path: '/icons-materialdesign', component: <IconMaterialdesign /> },
    { path: '/icons-fontawesome', component: <IconFontawesome /> },
    { path: '/icon-dripicons', component: <IconDripicons /> },
  
    // Ui/Maps Pages
    { path: '/maps-vector', component: <VectorMaps /> },
    { path: '/maps-google', component: <GoogleMap /> },

    // Ui/JSON Tools Pages
    { path: '/json-tools', component: <JSONToolsView /> }
  ] : []),


  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: '/',
    exact: true,
    component: <Navigate to="/dashboard" />
  },

  { path: '/permissao-negada', component: <ErrorPermissionDenied /> },
  { path: '/404', component: <Error404 /> },
  { path: '*', component: <SuspensePage /> },
]

const publicRoutes = [
  // Authentication Page
  { path: '/logout', component: <Logout /> },
  { path: LOGIN, component: <Login /> },
  { path: '/login', component: <Login /> },
  { path: '/forgot-password', component: <ForgetPasswordPage /> },
  { path: '/BI_AC0002', component: <ForgetPasswordPage /> },
  //{ path: '/termos-de-uso', component: <BI_EX0003 /> },
  //{ path: '/BI_EX0003', component: <BI_EX0003 /> },
  { path: '/BI_EX0003', component: <LegalContentPage /> },
  { path: '/BI_EX0004', component: <LegalContentPage /> },

  { path: '/BI_EX0000', component: <BI_EX0000 /> },

  // Utility Pages
  { path: '/pages-500', component: <Error500 /> },
  { path: '/pages-maintenance', component: <Maintenance /> },
  { path: '/pages-comingsoon', component: <ComingSoon /> }
]

export { authProtectedRoutes, publicRoutes }
